export const CERTIFICATE_TYPES = {
  VITIMA: 'Vítima',
  INVESTIGADO: 'Investigado',
  DELEGADO: 'Delegado',
  JUIZO: 'Juízo',
};

export const CERTIFICATE_TYPES_ARRAY = [
  CERTIFICATE_TYPES.INVESTIGADO,
  CERTIFICATE_TYPES.DELEGADO,
  CERTIFICATE_TYPES.VITIMA,
];
